<template>
  <a-ext-monit-link-check-box v-model="checkedList" :options="options" @change="onChange" />
</template>

<script>
    import mixin from '../mixin/AExtStringMixin'
    import AExtMonitLinkCheckBox from './AExtMonitLinkCheckBox'
    import MonitLink from '../All/LocalDic/MonitLink'
    export default {
        name: "index",
        components:{AExtMonitLinkCheckBox},
        mixins:[mixin],
        data() {
            return {
                checkedList:[],
                options:[],
                localValue: ''
            }
        },
        created(){
            this.init();
        },
        methods:{
            init(){
                this.options=MonitLink;
                if(this.localValue)
                {
                    this.checkedList=this.localValue.split(",");
                }
                else {
                    this.checkedList=[];
                }
            },
            onChange(checkedList)
            {
                this.localValue=checkedList.join(',');
            }
        }

    }
</script>

<style scoped>

</style>